import styled from 'styled-components'

export default styled.li`
  display: flex;
  flex-shrink: 0;
  height: 40px;
  padding: 0 0 0 8px;
  align-items: center;
  cursor: pointer;
  color: ${ ({ theme }) => theme.colors.typography.medium };

  &.selected {
    color: ${ ({ theme }) => theme.colors.typography.dark };
    background: ${ ({ theme }) => theme.colors.grey.light };
  }

  .label {
    font-size: 14px;
    font-family: ${ ({ theme }) => theme.fontFamily };
    pointer-events: none;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 0;
  }
  
  &:hover {
    color: ${ ({ theme }) => theme.colors.typography.dark };
    background: ${ ({ theme }) => theme.colors.grey.medium };
  }
`
